import { ReactNode } from 'react';

import { SupplierOnboardingRequestMessage } from '../../../../../../types/SupplierOnboardingRequestMessage';
import { OfferModel } from '../../../../../offer/model/OfferModel';
import { OrderModel } from '../../../../model/OrderModel';

import { OfferCardContext } from './OfferCardContext';

interface OfferCardContextProviderProps {
    offer: OfferModel;
    order: OrderModel;
    isLastOpenOffer?: boolean;
    isSpotAvailable?: boolean;
    onboarding?: SupplierOnboardingRequestMessage;
    children: ReactNode;
}

export const OfferCardContextProvider = ({
    children,
    offer,
    order,
    isLastOpenOffer = false,
    isSpotAvailable = false,
    onboarding,
}: OfferCardContextProviderProps) => {
    return (
        <OfferCardContext.Provider value={{ offer, order, isLastOpenOffer, isSpotAvailable, onboarding }}>
            {children}
        </OfferCardContext.Provider>
    );
};
